export * from './src/contacts-v4-attachment-attachments.schemas.js';
